import React from "react";
import { Box, Label } from "theme-ui";
import camelCase from "lodash/fp/camelCase";

import { useTranslation } from "hooks";
import SkateFieldSelector from "./SkateFieldSelector";
import * as styles from "./SkateCustomiseBlade.styles";
import { FORM_COMPONENTS } from "utils/constants";

export default function FormField({ onChange, value, ...props }) {
  const { t } = useTranslation();

  return (
    <Box sx={styles[camelCase(props.name)] || styles.field}>
      {props.label && props.component !== FORM_COMPONENTS.CHECKBOX && (
        <Label sx={styles.label}>{t(props.label)}</Label>
      )}

      <SkateFieldSelector {...props} onChange={onChange} value={value} />
    </Box>
  );
}
